import { requestIdHeader } from '@thinkalpha/common/contracts/x-headers.js';
import { AxiosError } from 'axios';
import { APIError } from 'src/api/error';
import type { ResponseData } from 'src/hooks/useSnackbar';
import { TradingSocketError } from 'src/services/TradingSocketService';
import type { SnackbarOptions } from 'src/store/actions/ui';

interface SnackbarErrorData {
    options: SnackbarOptions;
    responseData: ResponseData;
}

export function snackbarErrorData(error: Error): SnackbarErrorData {
    const responseData: ResponseData = {};

    if (error instanceof AxiosError) {
        responseData.requestId = error.response?.data?.requestId ?? error.config?.headers[requestIdHeader];
        responseData.debugMessage = error.response?.data?.debugMessage;
    } else if (error instanceof APIError) {
        responseData.requestId = error.requestId;
    } else if (error instanceof TradingSocketError) {
        responseData.requestId = error.requestId;
    }

    return { options: { variant: 'error' }, responseData };
}
